import { SortDirection } from "@angular/material";

export type RRE_FDMode = "MY_FORMS" | "ALL_FORMS";

export type RRE_FormType = "REAL_ESTATE" | "LAND_SERVICES";

export type RRE_FDColumnFilter = {
  value: string;
  viewValue: string;
};

export type RRE_FDColumn = {
  name?: RRE_FD_COLUMN_NAME;
  width?: string;
  sortable?: boolean;
  filter?: boolean;
};

export enum RRE_FD_TABS_ENUM {
  MY_FORMS = "My Forms",
  ALL_FORMS = "All Forms",
  ACTIVE = "Active",
  ASSIGNED_TO_REAL_ESTATE = "Assigned to Real Estate Funding",
  APPROVED = "Approved",
  DRAFTS = "Drafts",
  COMPLETED = "Completed",
  CANCELLED = "Cancelled",
}

export type RRE_FDTab = {
  name: string;
  type: RRE_FD_TABS_ENUM;
  mode: RRE_FDMode[];
  columns: RRE_FDColumn[];
  defaultSortColumn?: RRE_FD_COLUMN_NAME;
  defaultSortDirection?: SortDirection;
};

export enum RRE_FD_COLUMN_NAME {
  PROJECT_AND_VERSION = "Project Id and Version #",
  SHORT_DESCRIPTION = "Short Description",
  DEPARTMENT = "Department",
  STATUS = "Status",
  ASSIGNED_TO = "Assigned to",
  COORDINATOR = "Coordinator",
  LAST_UPDATED = "Last updated",
  DRAFT_OWNER = "Draft Owner",
  LAST_SAVED = "Last saved",
  PROJECT_ID = "Project ID",
  PROJECT_DESCRIPTION = "Project Description",
  ACTIVITY_ID = "Activity ID",
  ACCOUNT = "Account #",
  PROCESS_CODE = "Process Code",
  CAPITAL_OU = "Capital Operating Unit",
  OM_OU = "O&M Operating Unit",
  RESP_CENTER = "Responsbility Center",
  BUSINESS_UNIT = "Business Unit",
  RE_OPEN = "Re-Open",
  UPDATE = "Update",
  ACTUAL_IN_SERVICE_DATE = "Actual In-Service Date",
}

export type RRE_FDData = {
  id: string;
  projectId: string;
  projectVersion?: number;
  projectDescription: string;
  department: string;
  realEstateDepartment?: string;
  lastUpdated: string;
  status: RREFormStatus;
  assignedTo: string;
  coordinator?: string;
  createdBy: string;
  omOperatingUnits: string;
  capitalOperatingUnits: string;
  businessUnit: string;
  activityId: string;
  account: string;
  processCode: string;
  capitalOU: string;
  omOU: string;
  respCenter: string;
  buUnit: string;
  actualInServiceDate: string;
};

export enum RREFormStatus {
  CREATED = "Created",
  UNDER_REVIEW = "Under Review",
  REJECTED = "Rejected",
  CANCELLED = "Cancelled",
  IN_SERVICE = "In-Service",
  APPROVED = "Approved",
  DELETED = "Deleted",
}
